module.exports = {"420381001":"均州路街道","420381002":"大坝路街道","420381003":"丹赵路街道","420381005":"三官殿街道","420381100":"土关垭镇","420381101":"浪河镇","420381102":"丁家营镇","420381103":"六里坪镇","420381104":"盐池河镇","420381105":"均县镇","420381106":"习家店镇","420381107":"蒿坪镇","420381108":"石鼓镇","420381109":"凉水河镇","420381110":"官山镇","420381111":"龙山镇","420381400":"新港经济开发管理处","420381401":"牛河林业开发管理区","420381402":"白杨坪林业开发管理区","420381403":"大沟林业开发管理区","420381450":"武当山特区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420381.json
// module id = 1575
// module chunks = 0